import { environment } from 'nsdi-volto-frontend/config/environments';

const VoyagerSearchBarBlockSchema = {
  title: 'Voyager Search Bar',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['placeholder', 'searchPagePath'],
    },
    {
      id: 'map',
      title: 'Map Settings',
      fields: ['showMap', 'mapHeight', 'defaultZoom', 'defaultCenter'],
    },
    {
      id: 'api',
      title: 'API Configuration',
      fields: ['voyagerBaseUrl', 'voyagerConfigId'],
    },
  ],
  properties: {
    placeholder: {
      title: 'Search Placeholder',
      description: 'Placeholder text for the search input',
      type: 'string',
      default: 'What are you looking for?',
    },
    searchPagePath: {
      title: 'Search Page Path',
      description:
        'The path to navigate to when clicking the search button. Supports internal paths (e.g., /nsdi-search) or external URLs (e.g., https://example.com/search). Query parameters will be appended.',
      type: 'string',
      default: '/voyager-search',
    },
    showMap: {
      title: 'Show Map',
      description: 'Display the interactive map behind the search bar',
      type: 'boolean',
      default: true,
    },
    mapHeight: {
      title: 'Map Height',
      description: 'Height of the map in pixels (collapsed mode)',
      type: 'number',
      default: 400,
    },
    defaultZoom: {
      title: 'Default Zoom',
      description: 'Default zoom level for the map (1-18)',
      type: 'number',
      default: 2,
    },
    defaultCenter: {
      title: 'Default Center',
      description: 'Default center coordinates for the map (format: lat,lng)',
      type: 'string',
      default: '20,0',
    },
    voyagerBaseUrl: {
      title: 'Voyager API Base URL',
      description:
        'The base URL for the Voyager Search API. Options: https://odn.voyagersearch.com, https://ogc-sdi.voyagersearch.com, https://voyager.fas.usda.gov/voyager',
      type: 'string',
      default: environment.voyager.baseUrl,
    },
    voyagerConfigId: {
      title: 'Voyager Config ID',
      description:
        'The display configuration ID. Use D18D9C907361 for ODN, default for OGC-SDI, D176678659AD for USDA FAS',
      type: 'string',
      default: environment.voyager.displayId,
    },
  },
  required: [],
};

export default VoyagerSearchBarBlockSchema;
